export default __webpack_public_path__ + "static/media/logo-footer.c98e8e15.png";